/**
 * Strip raw markdown/HTML artifacts from passage text for clean display.
 * Handles: HTML comments, markdown images, markdown links (keep text),
 * HTML tags, heading markers, escaped underscores, excess whitespace.
 */
export function cleanPassageText(text: string): string {
  return text
    // Remove HTML comments <!-- ... -->
    .replace(/<!--[\s\S]*?-->/g, '')
    // Remove markdown images ![alt](url)
    .replace(/!\[[^\]]*\]\([^)]*\)/g, '')
    // Convert markdown links [text](url) → text
    .replace(/\[([^\]]*)\]\([^)]*\)/g, '$1')
    // Remove HTML tags
    .replace(/<[^>]+>/g, '')
    // Remove markdown heading markers
    .replace(/^#{1,6}\s+/gm, '')
    // Remove markdown bold/italic markers
    .replace(/\*{1,3}([^*]+)\*{1,3}/g, '$1')
    // Unescape underscores
    .replace(/\\_/g, '_')
    // Remove markdown horizontal rules
    .replace(/^[-*_]{3,}\s*$/gm, '')
    // Collapse multiple blank lines
    .replace(/\n{3,}/g, '\n\n')
    // Collapse multiple spaces
    .replace(/ {2,}/g, ' ')
    .trim()
}
